module.exports = __webpack_public_path__ + "staticVue/img/three.ebb24552.png";